import 'reflect-metadata';
import './dynamic-loading';
import './bootstrap';
import '@lottiefiles/lottie-player';
import "./transformers";
import './commands';
import "./comparators";
import "./services"; // Register all services with DI container
import "./actions"; // Register all UI actions with ActionRegistry (after DI setup, before components) — no unit test: import order verified by build (T8.13) + E2E (T8.14)

// Hydrate appState.user from auto-login cookie BEFORE the router runs.
// Without this, ha-app's router runs checkForAuthentication() against a
// stale (null) user and redirects to /auth/login despite a valid cookie.
//
// We register the hydration promise on the auth-hydration gate; the router
// enter-guards (routes.ts) and ha-app's connectedCallback await the gate
// before reading appState.isUserLoggedIn. This is more robust than a
// top-level await, which does not reliably gate the upgrade of the
// `<ha-app>` element already present in the document or side effects of
// transitively imported packages.
import {container} from "tsyringe";
import {AuthHydrationService} from "./services/auth-hydration.service";
import {setAuthHydrationPromise} from "./services/auth-hydration.gate";
setAuthHydrationPromise(container.resolve(AuthHydrationService).hydrateFromCookie());

import "./components";
import './message-broker/listeners';
import './message-broker/message-broker';
import "./views";
